import { FuseNavigationItem } from '@library/components/navigation';
import { ROLES } from 'shared-models';

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'home',
    title: 'Inicio',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/landing/home',
    roles: [ROLES.SUPERADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 'home-dashboard',
    title: 'Inicio',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/enterprise-dashboard',
    roles: [ROLES.ADMIN],
  },
  {
    id: 'time-tracking',
    title: 'Fichaje',
    type: 'basic',
    icon: 'mat_outline:access_time',
    link: '/time-tracking',
    roles: [ROLES.SUPERADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 'my-shifts',
    title: 'Mis turnos',
    type: 'basic',
    icon: 'mat_outline:event_available',
    link: '/mis-turnos',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.GESTOR],
  },
  {
    id: 'planner',
    title: 'Planificación',
    type: 'basic',
    icon: 'mat_outline:grid_view',
    link: '/planner',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER],
  },
  {
    id: 'admin-panel',
    title: 'Admin Panel',
    type: 'basic',
    icon: 'mat_outline:manage_accounts',
    link: '/admin/panel',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.GESTOR],
  },
  {
    id: 'file-manager-user',
    title: 'Mis Archivos',
    type: 'basic',
    icon: 'mat_outline:archive',
    link: '/files',
    roles: [ROLES.SUPERADMIN, ROLES.MANAGER, ROLES.USER],
  },
  {
    id: 'applications',
    title: 'Solicitudes',
    type: 'basic',
    icon: 'heroicons_outline:clipboard-document-check',
    link: '/applications',
    roles: [ROLES.SUPERADMIN, ROLES.MANAGER, ROLES.GESTOR, ROLES.USER],
  },
  {
    id: 'configuration-panel',
    title: 'Configuración',
    type: 'basic',
    icon: 'heroicons_outline:cog',
    link: '/configuration/panel',
    roles: [ROLES.SUPERADMIN, ROLES.CONFIG_ADMIN],
  },
  {
    id: 'analytics',
    title: 'Analíticas',
    type: 'basic',
    icon: 'heroicons_outline:chart-bar',
    link: '/analytics',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.GESTOR, ROLES.AUDITOR],
  },
  {
    id: 'reports',
    title: 'Informes',
    type: 'basic',
    icon: 'heroicons_outline:clipboard-document-list',
    link: '/reports',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.GESTOR, ROLES.AUDITOR],
  },

  {
    id: 'my-assignments',
    title: 'Mis proyectos',
    type: 'basic',
    icon: 'heroicons_outline:calendar-days',
    link: '/my-assignments',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER],
  },
  /*   {
    id: 'admin-shifts',
    title: 'Turnos',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/admin/shifts',
    roles: [ROLES.ADMIN, ROLES.MANAGER],
  }, */
];
